import { useQuery } from "@tanstack/react-query";
import { useDebounce } from "../../hooks";
import { searchMicroservice } from "./api";

export interface SearchPrototypeParams {
  baseUrl: string;
  query: string | undefined;
  debounceMs?: number;
  enabled?: boolean;
}

export function useSearchMicroservice({
  baseUrl,
  query,
  debounceMs = 300,
  enabled = true,
}: SearchPrototypeParams) {
  const debouncedSearchQuery = useDebounce(query, debounceMs);

  return useQuery({
    enabled: enabled && Boolean(debouncedSearchQuery),
    queryKey: ["search-microservice", debouncedSearchQuery],
    queryFn: () => searchMicroservice(baseUrl, debouncedSearchQuery || ""),
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
  });
}
